'use client';
import React from 'react';
import Link from 'next/link';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { useLanguage } from '@/lib/LanguageContext';
import { getTranslations } from '@/lib/i18n';

const milestonesEs = [
{ year: '2015', title: 'Fundación de Innobox', description: 'Nacimos con la misión de democratizar el acceso a tecnología de calidad para organizaciones chilenas de todos los tamaños.' },
{ year: '2017', title: 'Expansión de Servicios', description: 'Incorporamos ciberseguridad y desarrollo de software a medida, ampliando nuestra propuesta de valor para clientes del sector público y privado.' },
{ year: '2019', title: 'Alianzas Estratégicas', description: 'Formalizamos alianzas con marcas líderes globales, permitiéndonos ofrecer soluciones con estándares internacionales a precios competitivos.' },
{ year: '2021', title: 'Transformación Digital Acelerada', description: 'Apoyamos a más de 80 organizaciones en su proceso de digitalización durante la pandemia, consolidándonos como referente en el mercado nacional.' },
{ year: '2023', title: 'Innovación con IA', description: 'Integramos inteligencia artificial en nuestros servicios de consultoría y ciberseguridad, anticipándonos a las necesidades del mercado.' },
{ year: '2025', title: 'Liderazgo Regional', description: 'Alcanzamos presencia en 3 regiones de Chile con un equipo de más de 30 profesionales especializados en transformación digital.' }];


const milestonesFr = [
{ year: '2015', title: 'Fondation d\'Innobox', description: 'Nous sommes nés avec la mission de démocratiser l\'accès à la technologie de qualité pour les organisations chiliennes de toutes tailles.' },
{ year: '2017', title: 'Expansion des Services', description: 'Nous avons intégré la cybersécurité et le développement de logiciels sur mesure, élargissant notre proposition de valeur pour les clients des secteurs public et privé.' },
{ year: '2019', title: 'Alliances Stratégiques', description: 'Nous avons formalisé des alliances avec des marques leaders mondiales, nous permettant d\'offrir des solutions aux standards internationaux à des prix compétitifs.' },
{ year: '2021', title: 'Transformation Numérique Accélérée', description: 'Nous avons soutenu plus de 80 organisations dans leur processus de numérisation pendant la pandémie, nous consolidant comme référence sur le marché national.' },
{ year: '2023', title: 'Innovation avec l\'IA', description: 'Nous avons intégré l\'intelligence artificielle dans nos services de conseil et de cybersécurité, anticipant les besoins du marché.' },
{ year: '2025', title: 'Leadership Régional', description: 'Nous avons atteint une présence dans 3 régions du Chili avec une équipe de plus de 30 professionnels spécialisés en transformation numérique.' }];


const teamMembers = [
{ name: 'Juan Carlos Pérez', roleEs: 'CEO & Fundador', roleFr: 'PDG & Fondateur', bioEs: 'Ingeniero en Informática con más de 15 años de experiencia en transformación digital. Apasionado por conectar tecnología con propósito organizacional.', bioFr: 'Ingénieur en informatique avec plus de 15 ans d\'expérience en transformation numérique. Passionné par la connexion entre technologie et objectif organisationnel.', image: "https://img.rocket.new/generatedImages/rocket_gen_img_156ad4a09-1766382056450.png", linkedin: '#' },
{ name: 'María González', roleEs: 'Directora de Ciberseguridad', roleFr: 'Directrice de la Cybersécurité', bioEs: 'Especialista certificada en seguridad informática con experiencia en banca, salud y gobierno. Lidera nuestro equipo de protección digital.', bioFr: 'Spécialiste certifiée en sécurité informatique avec expérience dans la banque, la santé et le gouvernement. Elle dirige notre équipe de protection numérique.', image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a566c232-1782337913337.png", linkedin: '#' },
{ name: 'Carlos Muñoz', roleEs: 'Director de Desarrollo', roleFr: 'Directeur du Développement', bioEs: 'Arquitecto de software con foco en soluciones escalables. Ha liderado proyectos de transformación para más de 40 organizaciones en Chile.', bioFr: 'Architecte logiciel axé sur des solutions évolutives. Il a dirigé des projets de transformation pour plus de 40 organisations au Chili.', image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f1a3708f-1782337913479.png", linkedin: '#' },
{ name: 'Ana Rodríguez', roleEs: 'Gerente de Consultoría', roleFr: 'Responsable du Conseil', bioEs: 'MBA con especialización en gestión del cambio tecnológico. Experta en alinear estrategia de negocio con hoja de ruta digital.', bioFr: 'MBA spécialisée en gestion du changement technologique. Experte en alignement de la stratégie commerciale avec la feuille de route numérique.', image: "https://img.rocket.new/generatedImages/rocket_gen_img_107405a57-1782337911979.png", linkedin: '#' }];


const achievementsEs = [
{ number: '10+', label: 'Años de experiencia', icon: 'fas fa-calendar-check' },
{ number: '150+', label: 'Clientes satisfechos', icon: 'fas fa-users' },
{ number: '300+', label: 'Proyectos completados', icon: 'fas fa-project-diagram' },
{ number: '30+', label: 'Profesionales especializados', icon: 'fas fa-user-tie' },
{ number: '3', label: 'Regiones con presencia', icon: 'fas fa-map-marker-alt' },
{ number: '98%', label: 'Tasa de satisfacción', icon: 'fas fa-star' }];


const achievementsFr = [
{ number: '10+', label: 'Années d\'expérience', icon: 'fas fa-calendar-check' },
{ number: '150+', label: 'Clients satisfaits', icon: 'fas fa-users' },
{ number: '300+', label: 'Projets réalisés', icon: 'fas fa-project-diagram' },
{ number: '30+', label: 'Professionnels spécialisés', icon: 'fas fa-user-tie' },
{ number: '3', label: 'Régions avec présence', icon: 'fas fa-map-marker-alt' },
{ number: '98%', label: 'Taux de satisfaction', icon: 'fas fa-star' }];


const testimonialsEs = [
{ quote: 'Innobox transformó completamente nuestra infraestructura tecnológica. Su equipo entendió nuestras necesidades desde el primer día y entregó soluciones que realmente funcionan en el mundo real.', author: 'Roberto Sánchez', role: 'Director de TI', company: 'Hospital Regional del Sur', logo: 'fas fa-hospital' },
{ quote: 'La consultoría estratégica de Innobox nos permitió reducir costos operativos en un 35% y mejorar la eficiencia de nuestros procesos. Un socio tecnológico de confianza.', author: 'Patricia Vega', role: 'Gerente General', company: 'Municipalidad de Concepción', logo: 'fas fa-university' },
{ quote: 'Su equipo de ciberseguridad detectó vulnerabilidades críticas que otros proveedores habían pasado por alto. Hoy operamos con total tranquilidad gracias a Innobox.', author: 'Diego Morales', role: 'CTO', company: 'Fintech Andes Capital', logo: 'fas fa-building' },
{ quote: 'Las capacitaciones de Innobox elevaron las competencias digitales de todo nuestro equipo. Metodología práctica, contenido relevante y resultados medibles.', author: 'Claudia Torres', role: 'Directora de RRHH', company: 'Retail Pacífico S.A.', logo: 'fas fa-store' }];


const testimonialsFr = [
{ quote: 'Innobox a complètement transformé notre infrastructure technologique. Leur équipe a compris nos besoins dès le premier jour et a fourni des solutions qui fonctionnent vraiment dans le monde réel.', author: 'Roberto Sánchez', role: 'Directeur IT', company: 'Hôpital Régional du Sud', logo: 'fas fa-hospital' },
{ quote: 'Le conseil stratégique d\'Innobox nous a permis de réduire les coûts opérationnels de 35% et d\'améliorer l\'efficacité de nos processus. Un partenaire technologique de confiance.', author: 'Patricia Vega', role: 'Directrice Générale', company: 'Municipalité de Concepción', logo: 'fas fa-university' },
{ quote: 'Leur équipe de cybersécurité a détecté des vulnérabilités critiques que d\'autres fournisseurs avaient manquées. Aujourd\'hui, nous opérons en toute tranquillité grâce à Innobox.', author: 'Diego Morales', role: 'CTO', company: 'Fintech Andes Capital', logo: 'fas fa-building' },
{ quote: 'Les formations d\'Innobox ont élevé les compétences numériques de toute notre équipe. Méthodologie pratique, contenu pertinent et résultats mesurables.', author: 'Claudia Torres', role: 'Directrice RH', company: 'Retail Pacífico S.A.', logo: 'fas fa-store' }];


const valuesEs = [
{ icon: 'fas fa-handshake', title: 'Cercanía', description: 'Construimos relaciones de largo plazo basadas en confianza y comunicación transparente.' },
{ icon: 'fas fa-lightbulb', title: 'Innovación', description: 'Exploramos constantemente nuevas tecnologías para ofrecer soluciones que anticipen el futuro.' },
{ icon: 'fas fa-leaf', title: 'Sostenibilidad', description: 'Integramos criterios de responsabilidad ambiental y social en cada proyecto que desarrollamos.' },
{ icon: 'fas fa-bullseye', title: 'Resultados', description: 'Nos comprometemos con métricas concretas y entregamos valor medible en cada engagement.' }];


const valuesFr = [
{ icon: 'fas fa-handshake', title: 'Proximité', description: 'Nous construisons des relations à long terme basées sur la confiance et une communication transparente.' },
{ icon: 'fas fa-lightbulb', title: 'Innovation', description: 'Nous explorons constamment de nouvelles technologies pour offrir des solutions qui anticipent l\'avenir.' },
{ icon: 'fas fa-leaf', title: 'Durabilité', description: 'Nous intégrons des critères de responsabilité environnementale et sociale dans chaque projet que nous développons.' },
{ icon: 'fas fa-bullseye', title: 'Résultats', description: 'Nous nous engageons sur des métriques concrètes et livrons une valeur mesurable à chaque engagement.' }];


export default function AboutPage() {
  const { language } = useLanguage();
  const t = getTranslations(language);
  const a = t?.about;

  const milestones = language === 'fr' ? milestonesFr : milestonesEs;
  const achievements = language === 'fr' ? achievementsFr : achievementsEs;
  const testimonials = language === 'fr' ? testimonialsFr : testimonialsEs;
  const values = language === 'fr' ? valuesFr : valuesEs;

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Nunito Sans', 'Raleway', arial, sans-serif" }}>
      <Navbar />
      {/* Hero */}
      <section
        className="relative overflow-hidden flex items-end"
        style={{
          background: 'linear-gradient(135deg, #111 0%, #1a1a1a 60%, #222 100%)',
          minHeight: '420px',
          paddingTop: '140px',
          paddingBottom: '80px'
        }}>
        <div
          className="absolute inset-0 opacity-10"
          style={{ backgroundImage: 'radial-gradient(circle at 70% 50%, #1AEF0F 0%, transparent 60%)' }} />
        
        <div className="max-w-[1200px] mx-auto px-[35px] relative z-10 w-full">
          <div className="flex items-center gap-2 mb-6" style={{ fontSize: '14px' }}>
            <Link href="/" className="text-gray-400 hover:text-[#1AEF0F] transition-colors">{a?.breadcrumbHome}</Link>
            <span className="text-gray-600">/</span>
            <span className="text-[#1AEF0F]">{a?.breadcrumbAbout}</span>
          </div>
          <div className="max-w-2xl">
            <p className="text-[#1AEF0F] font-bold uppercase tracking-widest mb-3" style={{ fontSize: '13px' }}>
              {a?.tagline}
            </p>
            <h1
              className="text-white font-bold mb-5"
              style={{ fontSize: 'clamp(36px, 5vw, 64px)', lineHeight: '1.1em', fontFamily: "'Titillium Web', sans-serif" }}>
              {a?.heroTitle1} <span style={{ color: '#1AEF0F' }}>{a?.heroTitle2}</span>
            </h1>
            <p className="text-gray-300" style={{ fontSize: '18px', lineHeight: '1.6em', maxWidth: '560px' }}>
              {a?.heroSubtitle}
            </p>
          </div>
        </div>
      </section>
      {/* Mission & Vision */}
      <section className="py-24 bg-white">
        <div className="max-w-[1200px] mx-auto px-[35px]">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <p className="text-[#1AEF0F] font-bold uppercase tracking-widest mb-3" style={{ fontSize: '13px' }}>
                {a?.essenceTag}
              </p>
              <h2
                className="font-bold text-black mb-6"
                style={{ fontSize: 'clamp(28px, 3vw, 42px)', lineHeight: '1.15em', fontFamily: "'Titillium Web', sans-serif" }}>
                {a?.missionVisionTitle}
              </h2>
              <div className="space-y-8">
                <div className="border-l-4 border-[#1AEF0F] pl-6">
                  <h3 className="font-bold text-black mb-2" style={{ fontSize: '20px', fontFamily: "'Titillium Web', sans-serif" }}>
                    {a?.missionLabel}
                  </h3>
                  <p className="text-[#505050]" style={{ fontSize: '17px', lineHeight: '1.6em' }}>
                    {a?.missionText}
                  </p>
                </div>
                <div className="border-l-4 border-black pl-6">
                  <h3 className="font-bold text-black mb-2" style={{ fontSize: '20px', fontFamily: "'Titillium Web', sans-serif" }}>
                    {a?.visionLabel}
                  </h3>
                  <p className="text-[#505050]" style={{ fontSize: '17px', lineHeight: '1.6em' }}>
                    {a?.visionText}
                  </p>
                </div>
              </div>
            </div>
            <div className="relative">
              <img
                src="https://img.rocket.new/generatedImages/rocket_gen_img_19f5fd4fc-1773137238571.png"
                alt="Equipo Innobox trabajando en proyectos de transformación digital"
                className="w-full h-auto rounded-sm"
                style={{ maxWidth: '540px' }} />
              <div
                className="absolute -bottom-6 -left-6 bg-[#1AEF0F] p-6 hidden lg:block"
                style={{ width: '180px' }}>
                <p className="font-bold text-black" style={{ fontSize: '36px', fontFamily: "'Titillium Web', sans-serif", lineHeight: '1' }}>10+</p>
                <p className="text-black font-semibold" style={{ fontSize: '14px' }}>{a?.yearsLabel}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Values */}
      <section className="py-20" style={{ background: '#f8f8f8' }}>
        <div className="max-w-[1200px] mx-auto px-[35px]">
          <div className="text-center mb-14">
            <p className="text-[#1AEF0F] font-bold uppercase tracking-widest mb-3" style={{ fontSize: '13px' }}>
              {a?.valuesTag}
            </p>
            <h2
              className="font-bold text-black"
              style={{ fontSize: 'clamp(26px, 3vw, 38px)', lineHeight: '1.15em', fontFamily: "'Titillium Web', sans-serif" }}>
              {a?.valuesTitle}
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {values?.map((v, i) =>
            <div key={i} className="bg-white p-8 group hover:bg-[#1AEF0F] transition-colors duration-300">
                <div className="mb-5">
                  <i className={`${v?.icon} text-[#1AEF0F] group-hover:text-black transition-colors duration-300`} style={{ fontSize: '32px' }} />
                </div>
                <h3 className="font-bold text-black mb-3 group-hover:text-black" style={{ fontSize: '20px', fontFamily: "'Titillium Web', sans-serif" }}>
                  {v?.title}
                </h3>
                <p className="text-[#505050] group-hover:text-black" style={{ fontSize: '15px', lineHeight: '1.6em' }}>
                  {v?.description}
                </p>
              </div>
            )}
          </div>
        </div>
      </section>
      {/* Company History Timeline */}
      <section className="py-24 bg-white">
        <div className="max-w-[1200px] mx-auto px-[35px]">
          <div className="mb-14">
            <p className="text-[#1AEF0F] font-bold uppercase tracking-widest mb-3" style={{ fontSize: '13px' }}>
              {a?.historyTag}
            </p>
            <h2
              className="font-bold text-black"
              style={{ fontSize: 'clamp(26px, 3vw, 38px)', lineHeight: '1.15em', fontFamily: "'Titillium Web', sans-serif" }}>
              {a?.historyTitle}
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0">
            {milestones?.map((m, i) =>
            <div
              key={i}
              className="relative p-8 border border-gray-100 group hover:border-[#1AEF0F] transition-colors duration-300"
              style={{ borderLeft: i % 3 === 0 ? '4px solid #1AEF0F' : undefined }}>
                <span
                className="block font-bold text-[#1AEF0F] mb-2"
                style={{ fontSize: '13px', letterSpacing: '0.1em', fontFamily: "'Titillium Web', sans-serif" }}>
                  {m?.year}
                </span>
                <h3 className="font-bold text-black mb-3" style={{ fontSize: '18px', fontFamily: "'Titillium Web', sans-serif" }}>
                  {m?.title}
                </h3>
                <p className="text-[#505050]" style={{ fontSize: '15px', lineHeight: '1.6em' }}>
                  {m?.description}
                </p>
              </div>
            )}
          </div>
        </div>
      </section>
      {/* Achievements */}
      <section className="py-20" style={{ background: 'linear-gradient(135deg, #111 0%, #1a1a1a 100%)' }}>
        <div className="max-w-[1200px] mx-auto px-[35px]">
          <div className="text-center mb-14">
            <p className="text-[#1AEF0F] font-bold uppercase tracking-widest mb-3" style={{ fontSize: '13px' }}>
              {a?.achievementsTag}
            </p>
            <h2
              className="font-bold text-white"
              style={{ fontSize: 'clamp(26px, 3vw, 38px)', lineHeight: '1.15em', fontFamily: "'Titillium Web', sans-serif" }}>
              {a?.achievementsTitle}
            </h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
            {achievements?.map((a2, i) =>
            <div key={i} className="text-center group">
                <div className="mb-3">
                  <i className={`${a2?.icon} text-[#1AEF0F]`} style={{ fontSize: '28px' }} />
                </div>
                <p
                className="font-bold text-white mb-1"
                style={{ fontSize: 'clamp(28px, 3vw, 40px)', fontFamily: "'Titillium Web', sans-serif", lineHeight: '1' }}>
                  {a2?.number}
                </p>
                <p className="text-gray-400" style={{ fontSize: '13px', lineHeight: '1.4em' }}>
                  {a2?.label}
                </p>
              </div>
            )}
          </div>
        </div>
      </section>
      {/* Team */}
      <section className="py-24 bg-white">
        <div className="max-w-[1200px] mx-auto px-[35px]">
          <div className="mb-14">
            <p className="text-[#1AEF0F] font-bold uppercase tracking-widest mb-3" style={{ fontSize: '13px' }}>
              {a?.teamTag}
            </p>
            <h2
              className="font-bold text-black"
              style={{ fontSize: 'clamp(26px, 3vw, 38px)', lineHeight: '1.15em', fontFamily: "'Titillium Web', sans-serif" }}>
              {a?.teamTitle}
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {teamMembers?.map((member, i) => {
              const role = language === 'fr' ? member?.roleFr : member?.roleEs;
              const bio = language === 'fr' ? member?.bioFr : member?.bioEs;
              return (
                <div key={i} className="group">
                  <div className="relative overflow-hidden mb-5" style={{ aspectRatio: '1/1' }}>
                    <img
                      src={member?.image}
                      alt={`${member?.name} - ${role} en Innobox`}
                      className="w-full h-full object-cover object-top grayscale group-hover:grayscale-0 transition-all duration-500" />
                    <div className="absolute inset-0 bg-[#1AEF0F] opacity-0 group-hover:opacity-10 transition-opacity duration-300" />
                  </div>
                  <h3 className="font-bold text-black mb-1" style={{ fontSize: '18px', fontFamily: "'Titillium Web', sans-serif" }}>
                    {member?.name}
                  </h3>
                  <p className="text-[#1AEF0F] font-semibold mb-3" style={{ fontSize: '13px', letterSpacing: '0.05em' }}>
                    {role}
                  </p>
                  <p className="text-[#505050]" style={{ fontSize: '14px', lineHeight: '1.6em' }}>
                    {bio}
                  </p>
                </div>);

            })}
          </div>
        </div>
      </section>
      {/* Testimonials */}
      <section className="py-24" style={{ background: '#f8f8f8' }}>
        <div className="max-w-[1200px] mx-auto px-[35px]">
          <div className="text-center mb-14">
            <p className="text-[#1AEF0F] font-bold uppercase tracking-widest mb-3" style={{ fontSize: '13px' }}>
              {a?.testimonialsTag}
            </p>
            <h2
              className="font-bold text-black"
              style={{ fontSize: 'clamp(26px, 3vw, 38px)', lineHeight: '1.15em', fontFamily: "'Titillium Web', sans-serif" }}>
              {a?.testimonialsTitle}
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {testimonials?.map((t2, i) =>
            <div
              key={i}
              className="bg-white p-8 relative"
              style={{ borderTop: i % 2 === 0 ? '4px solid #1AEF0F' : '4px solid #111' }}>
                <div className="mb-6">
                  <i className="fas fa-quote-left text-[#1AEF0F]" style={{ fontSize: '28px', opacity: 0.4 }} />
                </div>
                <p className="text-[#505050] mb-8" style={{ fontSize: '16px', lineHeight: '1.7em' }}>
                  &ldquo;{t2?.quote}&rdquo;
                </p>
                <div className="flex items-center gap-4">
                  <div
                  className="flex items-center justify-center bg-[#1AEF0F] flex-shrink-0"
                  style={{ width: '48px', height: '48px' }}>
                    <i className={`${t2?.logo} text-black`} style={{ fontSize: '20px' }} />
                  </div>
                  <div>
                    <p className="font-bold text-black" style={{ fontSize: '15px', fontFamily: "'Titillium Web', sans-serif" }}>
                      {t2?.author}
                    </p>
                    <p className="text-[#505050]" style={{ fontSize: '13px' }}>
                      {t2?.role} · {t2?.company}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
      {/* CTA */}
      <section className="py-20" style={{ background: 'linear-gradient(90deg, #1AEF0F 0%, #0fd40e 100%)' }}>
        <div className="max-w-[1200px] mx-auto px-[35px] flex flex-col lg:flex-row items-center justify-between gap-8">
          <div>
            <h2
              className="font-bold text-black mb-3"
              style={{ fontSize: 'clamp(24px, 3vw, 36px)', lineHeight: '1.15em', fontFamily: "'Titillium Web', sans-serif" }}>
              {a?.ctaTitle}
            </h2>
            <p className="text-black" style={{ fontSize: '17px', opacity: 0.8 }}>
              {a?.ctaSubtitle}
            </p>
          </div>
          <div className="flex gap-4 flex-wrap">
            <a
              href="https://calendar.app.google/qrMMuz1WHJJ4eoab8"
              target="_blank"
              rel="noopener noreferrer"
              className="group relative inline-flex items-center overflow-hidden border-2 border-black text-black bg-transparent"
              style={{ padding: '14px 32px', fontSize: '15px', fontWeight: '700', transition: 'all 300ms ease-out', fontFamily: "'Nunito Sans', sans-serif" }}>
              <span className="relative z-10 transition-colors duration-300 group-hover:text-white">{a?.ctaBtnSchedule}</span>
              <span className="absolute inset-0 bg-black transform translate-x-full group-hover:translate-x-0 transition-transform duration-300" style={{ zIndex: 0 }} />
            </a>
            <Link
              href="/#servicios"
              className="group relative inline-flex items-center overflow-hidden border-2 border-black text-black bg-transparent"
              style={{ padding: '14px 32px', fontSize: '15px', fontWeight: '700', transition: 'all 300ms ease-out', fontFamily: "'Nunito Sans', sans-serif" }}>
              <span className="relative z-10 transition-colors duration-300 group-hover:text-white">{a?.ctaBtnServices}</span>
              <span className="absolute inset-0 bg-black transform translate-x-full group-hover:translate-x-0 transition-transform duration-300" style={{ zIndex: 0 }} />
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </div>);

}